import { render, staticRenderFns } from "./PosCheck.vue?vue&type=template&id=34942b42&scoped=true"
import script from "./PosCheck.vue?vue&type=script&lang=js"
export * from "./PosCheck.vue?vue&type=script&lang=js"
import style0 from "./PosCheck.vue?vue&type=style&index=0&id=34942b42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34942b42",
  null
  
)

export default component.exports